// copied from @bingads-webui-campaign-react/wizard-shared-components/utils/p$dadeRange to avoid depending on bing-maps
import Promise from 'bluebird';
import { WaterfallFilterStorage, WaterfallFilterType, waterfallDateFilterProcessor } from '@bingads-webui-campaign/filter-storage';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { useContext } from 'react';

function useDateRangeDefault() {
  const preferenceService = useContext(PreferenceContext);
  const serverContext = useContext(ServerContext);
  const waterfallFilterStorage = new WaterfallFilterStorage({
    preferenceService,
  });
  const waterFallDateFilters = waterfallFilterStorage.getFilters([WaterfallFilterType.DateFilter]);
  const dateFilter = waterfallDateFilterProcessor(waterFallDateFilters, serverContext);
  return dateFilter;
}

export function useP$DaterangeDefault() {
  const dateFilter = useDateRangeDefault();
  return Promise.resolve(dateFilter);
}
